import React, { ReactNode } from "react";
import classnames from "classnames";
import styles from "../styles/Badge.module.scss";

type Props = {
  children: ReactNode;
  isLarge?: boolean;
  isYellow?: boolean;
  isRed?: boolean;
  isGreen?: boolean;
};

export const Badge: React.FC<Props> = (props) => {
  const { isLarge, isGreen, isYellow, isRed, children } = props;

  const cls = classnames(styles.badge, {
    [styles.badgeLarge]: isLarge,
    [styles.badgeYellow]: isYellow,
    [styles.badgeGreen]: isGreen,
    [styles.badgeRed]: isRed,
  });

  return <div className={cls}> {children} </div>;
};
